import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "select is-fullwidth" }
const _hoisted_5 = { disabled: "" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "control mb-1" }
const _hoisted_10 = { class: "control mb-1" }
const _hoisted_11 = { class: "control mb-1" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "control" }

import { Address, AddressInterface } from '@/interfaces/admin/address'
import { ref, computed, onMounted, watch, PropType } from 'vue'
import { useStore } from 'vuex';
import i18n from '@/locales';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressForm',
  props: {
  address: {
    type: Object as PropType<AddressInterface | null>,
    required: false,
    default: null
  },
  isRequired: {
    type: Boolean,
    default: false
  }
},
  emits: ['update'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const countryCode = ref(props.address?.countryCode || '');
const line1 = ref(props.address?.line1 || '');
const line2 = ref(props.address?.line2 || '');
const line3 = ref(props.address?.line3 || '');
const city = ref(props.address?.city || '');
const state = ref(props.address?.state || '');
const zipCode = ref(props.address?.zipCode || '');
const placeId = ref(props.address?.placeId || '');

const countryCodes = computed(() => store.state.countrycodes.items);

const isFormValid = computed(() => {
  if (props.isRequired) {
    switch (countryCode.value) {
      case 'USA':
        return !!(line1.value && city.value && countryCode.value);
      default:
        return !!(line1.value && countryCode.value);
    }
  }
  return true;
});

const isUSA = computed(() => countryCode.value === 'USA');

const getAddressData = () => new Address({
  countryCode: countryCode.value,
  line1: line1.value,
  line2: line2.value,
  line3: line3.value,
  city: city.value,
  state: state.value,
  zipCode: zipCode.value,
  placeId: placeId.value
});

// Method to populate form from address data (e.g., from place details)
const populateFromAddress = (addressData: AddressInterface) => {
  isManualChange = false; // Prevent clearing placeId on programmatic update
  countryCode.value = addressData.countryCode || '';
  line1.value = addressData.line1 || '';
  line2.value = addressData.line2 || '';
  line3.value = addressData.line3 || '';
  city.value = addressData.city || '';
  state.value = addressData.state || '';
  zipCode.value = addressData.zipCode || '';
  placeId.value = addressData.placeId || '';
  // Re-enable manual change detection after next tick
  setTimeout(() => { isManualChange = true; }, 0);
};

// Expose method to parent components
__expose({
  populateFromAddress
});

// Track if this is a manual change (user typing) vs programmatic change
let isManualChange = true;

// Watch for changes in any form field and emit an update
// Clear placeId on manual changes to indicate address is no longer validated
watch([countryCode, line1, line2, line3, city, state, zipCode], () => {
  if (isManualChange && placeId.value) {
    placeId.value = ''; // Clear placeId when user manually changes address
  }

  emit('update', {
    address: getAddressData(),
    isFormValid: isFormValid.value
  });
});

store.dispatch('countrycodes/getCountryCodes');

onMounted(() => {
  isManualChange = false; // Prevent clearing placeId on initial mount

  if (props.address) {
    countryCode.value = props.address.countryCode ?? '';
    line1.value = props.address.line1 ?? '';
    line2.value = props.address.line2 ?? '';
    line3.value = props.address.line3 ?? '';
    city.value = props.address.city ?? '';
    state.value = props.address.state ?? '';
    zipCode.value = props.address.zipCode ?? '';
    placeId.value = props.address.placeId ?? '';
  }

  if (!countryCode.value && i18n.global.locale === 'en-US') {
    countryCode.value = 'USA';
  }

  // Re-enable manual change detection after next tick
  setTimeout(() => { isManualChange = true; }, 0);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$tc('country', 1)), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((countryCode).value = $event)),
            class: _normalizeClass({'is-danger': !isFormValid.value})
          }, [
            _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t('selectAField', {field: _ctx.$t('country')})), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryCodes.value, (country) => {
              return (_openBlock(), _createElementBlock("option", {
                key: country.key,
                value: country.key
              }, _toDisplayString(country.name), 9, _hoisted_6))
            }), 128))
          ], 2), [
            [_vModelSelect, countryCode.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('line')), 1),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((line1).value = $event)),
          class: "input",
          type: "text",
          maxlength: "255"
        }, null, 512), [
          [_vModelText, line1.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((line2).value = $event)),
          class: "input",
          type: "text",
          maxlength: "255"
        }, null, 512), [
          [_vModelText, line2.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((line3).value = $event)),
          class: "input",
          type: "text",
          maxlength: "255"
        }, null, 512), [
          [_vModelText, line3.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('city')), 1),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((city).value = $event)),
          class: "input",
          type: "text",
          maxlength: "255"
        }, null, 512), [
          [_vModelText, city.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", _hoisted_16, _toDisplayString(!isUSA.value ? _ctx.$t('province'): _ctx.$t('state')), 1),
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state).value = $event)),
          class: "input",
          type: "text",
          maxlength: "255"
        }, null, 512), [
          [_vModelText, state.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("label", _hoisted_19, _toDisplayString(!isUSA.value ? _ctx.$t('postalCode') : _ctx.$t('zipCode')), 1),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((zipCode).value = $event)),
          class: "input",
          type: "text",
          maxlength: "255"
        }, null, 512), [
          [_vModelText, zipCode.value]
        ])
      ])
    ])
  ]))
}
}

})